<template>
  <div class="flex justify-center flex-wrap -m-3">
    <div class="p-3" v-for="option in banks" :key="`cf${option.value}`">
      <button
        type="button"
        class="border-2px transition-colors duration-300 focus:outline-none"
        :class="
          option.value === getPaymentMethodKey
            ? 'border-blue'
            : 'border-gray-200'
        "
        @click="setPaymentMethodKey(option.value)"
      >
        <img
          class="h-16 w-56"
          :src="option.image"
          :alt="option.label"
          v-if="option.image"
        />
        <template v-else>{{ option.label }}</template>
      </button>
    </div>
  </div>

  <div class="text-center mt-12" v-if="hasVisaPayment">
    <p class="mb-2">{{ __('online_transactions_safe_description') }}</p>

    <div class="flex justify-center -m-2">
      <div class="p-2">
        <img
          :src="`./ui/images/bank/mastercard_id_check_vertical.svg`"
          alt="Mastercard ID-check"
          class="h-20"
        />
      </div>

      <div class="p-2">
        <img
          :src="`./ui/images/bank/visa_secure_vertical.svg`"
          alt="Visa Secure"
          class="h-20"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import useBank from '@/stores/Bank';
import useBasket from '@/stores/Basket';
import usePayment from '@/stores/Payment';
import Translation from '@/libraries/Translation';

export default {
  name: 'Banks',
  setup() {
    const { isAllowInvoicePayment } = useBasket();
    const { getFilteredBanks } = useBank();
    const { getPaymentMethodKey, setPaymentMethodKey } = usePayment();

    const banks = computed(() => {
      let collect = [];
      const list = getFilteredBanks();

      if (list.options) {
        collect = [...list.options];
        if (list.value) {
          setPaymentMethodKey(list.value);
        }
      }

      if (isAllowInvoicePayment()) {
        collect.push({
          label: Translation('invoice_payment_label'),
          value: 'invoice'
        });
      }

      return collect;
    });

    const hasVisaPayment = computed(() => {
      const list = getFilteredBanks();

      let hasCard = false;

      [...list.options].forEach(option => {
        if (option.value.includes('card')) {
          hasCard = true;
        }
      });

      return hasCard;
    });

    return {
      banks,
      getPaymentMethodKey: computed(() => getPaymentMethodKey()),
      setPaymentMethodKey,
      hasVisaPayment
    };
  }
};
</script>
